import { AfterViewInit, Component, Inject } from '@angular/core';
import * as angular from 'angular';
import { downgradeComponent } from '@angular/upgrade/static';
import { Store } from '@ngrx/store';
import { GenericListType, LoadMoreQuery } from '../../../common/components/lists/generic-list.component';
import { AppState } from '../../../store';
import {
  closeAccountsModal,
  getAccountsList,
  loadMoreAccountsList,
  openAccountsModal,
} from '../../store/accounts/accounts.actions';
import {
  selectAccounts,
  selectAccountsErrorFlag,
  selectAccountsIsModalOpenFlag,
  selectAccountsLoadingFlag,
  selectAreAllAccountsLoadedFlag,
} from '../../store/accounts/accounts.selectors';
import { QueryParamsAccountsList } from '../../../common/helper/query-params-generic-list.helper';

@Component({
  selector: 'accounts-list',
  template: `
    <generic-list
      [type]="type"
      [items]="accounts$ | async"
      [isLoading]="accountsLoading$ | async"
      [hasNewButton]="true"
      (createClick)="openCreateModal()"
      [newBtnText]="'account.generic-object.buttons.new' | translate"
      [emptyTitle]="'account.generic-object.empty.title' | translate"
      [emptyDescription]="'account.generic-object.empty.description' | translate"
      (loadMore)="loadMoreAccounts($event)"
      [limit]="queryParams.limit"
      [allItemsLoaded]="areAllAccountsLoaded$ | async"
      [isError]="accountsError$ | async"
    >
      <ng-template templateName="listItem" let-item>
        <account-list-item [item]="item"></account-list-item>
      </ng-template>
    </generic-list>
    <xp-modal
      [isOpen]="isModalOpen$ | async"
      [closeButtonText]="'account.generic-object.buttons.close' | translate"
      [saveButtonText]="'account.generic-object.buttons.save' | translate"
      [titleText]="'account.generic-object.title' | translate"
      (close)="onModalClose()"
    >
      <ng-template>
        <account-form></account-form>
      </ng-template>
    </xp-modal>
  `,
})
export class AccountsListComponent implements AfterViewInit {
  type = GenericListType.accounts;
  accountsLoading$ = this.store.select(selectAccountsLoadingFlag);
  accountsError$ = this.store.select(selectAccountsErrorFlag);
  isModalOpen$ = this.store.select(selectAccountsIsModalOpenFlag);
  accounts$ = this.store.select(selectAccounts);
  areAllAccountsLoaded$ = this.store.select(selectAreAllAccountsLoadedFlag);
  queryParams = QueryParamsAccountsList;

  constructor(@Inject('$rootScope') private $rootScope: any, private store: Store<AppState>) {
    this.store.dispatch(getAccountsList({ params: this.queryParams }));
  }

  ngAfterViewInit() {
    if (this.$rootScope.stateIs('app.account.settings.my.accounts.new')) {
      this.openCreateModal();
    }
  }

  // eslint-disable-next-line class-methods-use-this
  openCreateModal(): void {
    this.$rootScope.stateGo('app.account.settings.my.accounts.new');
    this.store.dispatch(openAccountsModal());
  }

  onModalClose(): void {
    this.$rootScope.stateGo('app.account.settings.my.accounts');
    this.store.dispatch(closeAccountsModal());
  }

  loadMoreAccounts(query: LoadMoreQuery) {
    const params: any = {
      ...this.queryParams,
      ...query,
    };
    this.store.dispatch(loadMoreAccountsList({ params }));
  }
}

((window as any).xplenty as angular.IModule).directive(
  'accountsList',
  downgradeComponent({
    component: AccountsListComponent,
  }),
);
